import { ReactElement, ReactNode } from 'react'
import { Info } from 'components'

import * as S from './styles'

interface StatisticsCardProps {
  icon: ReactNode
  title: string
  mainValue: string
  titleTooltip?: string
  childrenOrientation?: 'row' | 'column'
  children: ReactElement
}

export const StatisticsCard = ({
  icon,
  mainValue,
  title,
  titleTooltip,
  childrenOrientation = 'column',
  children
}: StatisticsCardProps) => {
  return (
    <S.StatisticContainer>
      <S.TitleRow>
        <S.IconContainer>{icon}</S.IconContainer>
        <S.TitleCol>
          <S.Row>
            <span>{title}</span>
            {titleTooltip && <Info iconSize={10}>{titleTooltip}</Info>}
          </S.Row>
          <h5>{mainValue}</h5>
        </S.TitleCol>
      </S.TitleRow>

      <S.DetailsCol childrenOrientation={childrenOrientation}>{children}</S.DetailsCol>
    </S.StatisticContainer>
  )
}
